<template>
    <a href="javascript:;"
        :class="[
            'cart_order_address_item',
            {'select_address': select_address.address_id == addressItem.address_id}
        ]"
        @click="setSelectAddress(addressItem)">
        <!-- 名字 & 电话号码行 -->
        <el-row :gutter="10">
            <!-- 名字 -->
            <el-col :span="12">
                <div class="cart_order_address_item_msg">{{addressItem.consignee || "&nbsp;"}}</div>
            </el-col>
            <!-- 电话 -->
            <el-col :span="12">
                <div class="cart_order_address_item_msg">{{addressItem.mobile || "&nbsp;"}}</div>
            </el-col>
        </el-row>
        <!-- 邮箱 -->
        <el-row :gutter="10">
            <el-col>
                <div class="cart_order_address_item_msg">{{addressItem.email || "&nbsp;"}}</div>
            </el-col>
        </el-row>
        <!-- 地址 -->
        <el-row :gutter="10">
            <el-col>
                <div class="cart_order_address_item_msg">{{addressItem.address || "&nbsp;"}}</div>
            </el-col>
        </el-row>
        <!-- 修改按钮 -->
        <div class="cart_order_address_item_change">
            <el-button
                type="text"
                size="mini"
                @click="getAddressDetail(addressItem.address_id)">
                <span>{{$t("public.modifyBtn")}}</span>
            </el-button>
        </div>
    </a>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
    props: [ "addressItem" ],
    computed: mapState({
        select_address: state => state.order.select_address
    }),
    methods: {
        ...mapMutations([
            "setSelectAddress"
        ]),
        ...mapActions([
            "getAddressDetail"
        ]),
    },
}
</script>

<style>
/* 组件盒子 */
.cart_order_address_item{
    display: block;
    height: 115px;
    padding: 5px;
    color: #333;
    border: 1px solid #EBEEF5;
}
.select_address{
    border-color: #ff6700;
}
.cart_order_address_item:hover{
    color: #ff6700;
}
/* 行间距 */
.cart_order_address_item>.el-row{
    margin-bottom: 5px;
}
/* .cart_order_address_item>.el-row:last-child{
    margin: 0;
} */
/* 内容 */
.cart_order_address_item_msg{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 修改按钮 */
.cart_order_address_item_change{
    text-align: right;
}
</style>
